import React from "react";
import { ContentContainer, MetaGrid, PageHeader, astryx } from "@shadowcue/ui";

export interface IContactForm {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
}

interface ContactFormProps {
  values: IContactForm;
  onChange: (values: IContactForm) => void;
  loading?: boolean;
}

const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const ContactForm = ({
  values,
  onChange,
  loading = false,
}: ContactFormProps) => {
  const isEditing = values.id !== undefined;

  const updateField = (field: keyof IContactForm, value: string) => {
    onChange({ ...values, [field]: value });
  };

  return (
    <ContentContainer loading={loading}>
      <PageHeader
        title={isEditing ? "Edit contact" : "New contact"}
        description={
          isEditing ? "Update contact details." : "Create a new contact."
        }
      />

      <MetaGrid>
        <astryx.TextInput
          label="First name"
          isRequired
          value={values.firstName}
          onChange={(value: string) => updateField("firstName", value)}
          placeholder="Joe"
          width="100%"
        />

        <astryx.TextInput
          label="Last name"
          isRequired
          value={values.lastName}
          onChange={(value: string) => updateField("lastName", value)}
          placeholder="Smith"
          width="100%"
        />

        <astryx.TextInput
          label="Email"
          type="email"
          isRequired
          value={values.email}
          onChange={(value: string) => updateField("email", value)}
          placeholder="contact@example.com"
          width="100%"
        />

        <astryx.Selector
          label="Status"
          value={values.status}
          options={STATUS_OPTIONS}
          onChange={(value: string) => updateField("status", value)}
          width="100%"
        />
      </MetaGrid>
    </ContentContainer>
  );
};

export default ContactForm;
